import { inject, Injectable } from '@angular/core';
import { AuthActions } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { AppModulesClientService, AuthServiceClientService, ClientMapper, ModuleMapper, RealmMapper } from '@shared/data';
import { map, Observable, switchMap } from 'rxjs';
import { ApplicationType } from '../enum/application-type.enum';
import { ModuleType } from '../enum/module-type.enum';
import { IModuleModel } from '../interface/module/module.model';
import { ModulePwaSettings } from '../interface/module/settings/module-pwa-settings';
import { ModuleSettingsRealm } from '../interface/module/settings/module-settings-realm';
import { SharedAppState } from '../store/app/app.state';
@Injectable({
    providedIn: 'root',
})
export abstract class BaseAppInitManagerService {
    protected readonly appModulesClientService = inject(AppModulesClientService);
    protected readonly store = inject(Store);
    protected readonly authServiceClientService = inject(AuthServiceClientService);

    abstract appType$: Observable<ApplicationType | undefined>;
    abstract appInitError$: Observable<boolean>;
    abstract appModules$: Observable<IModuleModel<unknown>[] | undefined>;
    abstract appPwaSettings$: Observable<ModulePwaSettings | undefined>;

    abstract setAppInitError(): Observable<void>;
    abstract loadAppModules(): Observable<IModuleModel[]>;

    public getRealmAndClient(): Observable<unknown> {
        return this.store.selectOnce(SharedAppState.appModules$).pipe(
            switchMap(appModules => {
                const realmModule = new ModuleMapper().mapModulesToTypedModule<ModuleSettingsRealm>(ModuleType.REALM, appModules as IModuleModel[]);
                return this.authServiceClientService
                    .getRealm(realmModule.settings.realmName)
                    .pipe(map(responseDto => ({ realmModule, responseDto })));
            }),
            switchMap(({ realmModule, responseDto }) => {
                const realmModel = new RealmMapper().mapDtoToModel(responseDto);
                return this.store.dispatch(new AuthActions.SetRealm(realmModel)).pipe(map(() => realmModule));
            }),
            switchMap(realmModule => {
                return this.authServiceClientService.getClient(realmModule.settings.realmName, realmModule.settings.clientId);
            }),
            switchMap(responseDto => {
                const clientModel = new ClientMapper().mapDtoToModel(responseDto);
                return this.store.dispatch(new AuthActions.SetClient(clientModel));
            }),
        );
    }
}
